module.exports = {
  title: "Lingua.community",
  serviceWorker: {
    NEW_VERSION_AVAILABLE: {
      content: "Доступна новая версия!",
    },
    INSTALL_RECOMMENDATION: {
      title: "Установка приложения",
      content:
        "Установите приложение Lingua Community для более удобного использования нашей платформы.",
      iosSteps: `Чтобы установить приложение на ваше устройство, выполните следующие действия:<ol class="mt-4"><li class="mb-2"><div>Нажмите "Поделиться"</div><div><img alt="Шаг 1" class="fill-width" src="/pwa/installation/ios/step1.jpeg"></div><li class="mb-2"><div>Нажмите "На экран «Домой»"</div><div><img alt="Шаг 2" class="fill-width" src="/pwa/installation/ios/step2.jpeg"></div><li class="mb-2"><div>Нажмите "Добавить"</div><div><img alt="Шаг 3" class="fill-width" src="/pwa/installation/ios/step3.jpeg"></div><li class="mb-2"><div>Найдите приложение на "Домашнем экране"</div><div><img alt="Шаг 4" class="fill-width" src="/pwa/installation/ios/step4.jpeg"></div></ol>`,
      install: "Установить",
    },
  },
  autoMessages: {
    CONNECT: `
    Привет!
    Я хотел(а) бы связаться с вами.
    `,
    BOOK_LESSON: `
    Привет!
    Я хотел(а) бы записаться к вам на урок.
    `,
  },
  validators: {
    required: "Это поле обязательно",
    minValue: "Минимальное значение: {value}",
    maxValue: "Максимальное значение: {value}",
    minArrayValue: "Минимальное количество вариантов: {value}",
    maxArrayValue: "Максимальное количество вариантов: {value}",
    passwordMustMatch: "Пароли должны совпадать",
    invalidEmail: "Некорректный email",
    maxLength: "Максимальная длина: {length} символов",
    selectAtLeastOne: "Выберите хотя бы один вариант",
    firstName: "Требуется имя",
    lastName: "Требуется фамилия",
    mustSelect: "Вы должны выбрать {length} критерий",
    optionalPrefix: "(опц.)",
  },
  errorMessages: {
    LESSON_NOT_FOUND: "Урок не найден",
    "Failed to fetch":
      "Проблемы с подключением. Проверьте интернет и попробуйте снова",
    REQUIRED_DRAGGABLE_MARKED_SYMBOL:
      "Требуется помеченная перетаскиваемая фраза",
    REQUIRED_DRAGGABLE_MARKED_SYMBOL_MIN_1:
      "Требуется минимум 1 помеченная перетаскиваемая фраза",
    REQUIRED_FIELD_MARKED_SYMBOL: "Требуется помеченная полевая фраза",
    REQUIRED_FIELD_MARKED_SYMBOL_MIN_1:
      "Требуется минимум 1 помеченная полевая фраза",
    REQUIRED_SYNONYM_MARKED_SYMBOL: "Требуется помеченная фраза синонима",
    REQUIRED_REAL_SYNONYM_MARKED_SYMBOL:
      "Требуется настоящая помеченная фраза синонима",
    REQUIRED_FAKE_SYNONYM_MARKED_SYMBOL:
      "Требуется ложная помеченная фраза синонима",
    SYNONYM_MARKED_SYMBOL_MUST_BE_1:
      "Требуется ровно 1 помеченная фраза синонима",
    REAL_SYNONYM_MARKED_SYMBOL_MUST_BE_1:
      "Требуется ровно 1 настоящая помеченная фраза синонима",
    REQUIRED_FAKE_SYNONYM_MARKED_SYMBOL_MIN_1:
      "Требуется минимум 1 ложная помеченная фраза синонима",
    REQUIRED_REAL_PLACE_MARKED_SYMBOL:
      "Требуется настоящая помеченная фраза места",
    REQUIRED_FAKE_PLACE_MARKED_SYMBOL:
      "Требуется ложная помеченная фраза места",
    REAL_PLACE_MARKED_SYMBOL_MUST_BE_1:
      "Требуется ровно 1 настоящая помеченная фраза места",
    REQUIRED_FAKE_PLACE_MARKED_SYMBOL_MIN_1:
      "Требуется минимум 1 ложная помеченная фраза места",
    REQUIRED_CORRECT_OR_WRONG_MARKED_SYMBOL:
      "Требуется помеченная фраза правильного/неправильного",
    REQUIRED_CORRECT_OR_WRONG_MARKED_SYMBOL_MIN_1:
      "Требуется минимум 1 помеченная фраза правильного/неправильного",
    USER_EMAIL_ALREADY_CREATED:
      "Пользователь с таким email уже зарегистрирован",
    INVALID_PERMISSIONS:
      "Ресурс в настоящее время недоступен. <br /> Похоже, к ресурсу применены настройки конфиденциальности.",
  },
  pages: {
    common: {
      profile: "Профиль",
      balance: "Баланс: <b>${value}</b>",
      visitProfile: "Посетить профиль",
      profileSettings: "Настройки профиля",
      logout: "Выйти",
      message: "Сообщение",
      connect: "Связаться",
      joinToConnect: "Присоединиться для связи",
      removeConnection: "Удалить",
      pending: "Ожидание",
      acceptInvitation: "Принять",
      declineInvitation: "Отклонить",
      filters: "Фильтры",
      id: "ID",
      cancel: "Отмена",
      add: "Добавить",
      share: "Поделиться",
      repost: "Репост",
      repostWithYourThoughts: "Репост с вашими мыслями",
      send: "Отправить",
      submit: "Отправить",
      apply: "Применить",
      save: "Сохранить",
      unsave: "Убрать из сохранённых",
      like: "Нравится",
      unlike: "Не нравится",
      comment: "Комментировать",
      likes: "Лайк(ов)",
      comments: "Комментарий(ев)",
      login: "Войти",
      signIn: "Войти",
      signUp: "Зарегистрироваться",
      create: "Создать",
      update: "Обновить",
      edit: "Редактировать",
      reset: "Сбросить",
      close: "Закрыть",
      delete: "Удалить",
      loading: "Загрузка",
      loadMore: "Загрузить ещё",
      oops: "Упс",
      reload: "Перезагрузить",
      copied: "Скопировано",
      searchAnyPerson: "Поиск любого человека",
      typeAnyPersonsName: "Введите имя любого человека",
      noMatchingUsers: "Нет подходящих пользователей",
      searchForUsers: "Поиск пользователей",
      seeAllResults: "Посмотреть все результаты",
      search: "Поиск",
      show: "Показать",
      showMore: "показать больше",
      showLess: "показать меньше",
      untitled: "Без названия",
      unnamed: "Без имени",
      copyLink: "Копировать ссылку",
      preview: "Предпросмотр",
      moveUp: "Поднять",
      moveDown: "Опустить",
      fork: "Сохранить",
      unfork: "Убрать из сохранённых",
      actions: "Действия",
      tabs: {
        main: "Главная",
        home: "Главная",
        myNetwork: "Моя сеть",
        lessons: "Уроки",
        messages: "Сообщения",
        materials: "Материалы",
        lessonBoards: "Доски",
        notifications: "Уведомления",
      },
      download: "Скачать",
      uploading: "Загрузка...",
      next: "Далее",
      done: "Готово",
      new: "Новый",
      rename: "Переименовать",
      back: "Назад",
      category: {
        saved: "Сохранённые",
        categories: "Категории",
        title: "Категория",
        newTitle: "Новая категория",
        editTitle: "Редактировать категорию",
        addCategory: "Добавить категорию",
        form: {
          title: "Название",
        },
      },
      linkToShare: "Ссылка для общего доступа",
      select: "Выбрать",
      selected: "Выбрано",
      nItemsSelected: "Выбрано: {value}",
      more: "Ещё",
    },
    feed: {
      form: {
        content: {
          placeholder: "Напишите, что у вас на уме...",
        },
      },
      noFeedsFound: "Нет записей",
      post: "Опубликовать",
      photoOrVideo: "Фото / Видео",
      addMaterial: "Добавить материал",
      repostDescription: {
        repost: "Мгновенно поделиться записью",
        repostWithYourThoughts: "Создать новую запись на основе текущей",
      },
      copyLinkToPost: "Копировать ссылку на запись",
      selectUsersToSend: "Выберите пользователей для отправки",
    },
    comment: {
      form: {
        content: {
          commentPlaceholder: "Добавьте комментарий...",
          replyPlaceholder: "Добавьте ответ...",
        },
      },
      comment: "Комментировать",
      noCommentsAddedYet: "Комментариев пока нет",
      commentNow: "Прокомментировать",
      loadMoreComments: "Загрузить больше комментариев",
      reply: "Ответить",
      replyingTo: "Ответ на:",
      viewMoreReplies: "Показать больше ответов ({value})",
      viewReplies: "Показать ответы ({value})",
    },
    mediaEditor: {
      title: "Редактор",
      upload: {
        selectAFileToBegin: "Выберите файл для начала",
        sharePhotoOrVideoInYourPost: "Добавьте фото или видео в запись",
        uploadFromYourDevice: "Загрузить с устройства",
        dragYourFilesHere: "Перетащите файлы сюда",
        dropYourFileHere: "Перетащите файл сюда",
        dropYourFilesHere: "Перетащите файлы сюда",
      },
    },
    home: {
      leftContainerDescription:
        "Место, где студенты и преподаватели со всего мира достигают высоких результатов без посредников",
      aboutUs: "О нас",
      iAmAStudent: "Я студент",
      iAmATeacher: "Я преподаватель",
    },
    promo: {
      student: {
        title: "Более 100 профессиональных преподавателей, которым доверяют",
        description:
          "Студенты оценивают преподавателей по эффективности обучения. На основе оценок мы рекомендуем лучших",
        howEffectiveWasLesson: "Насколько эффективным был ваш урок?",
        submitGrade: "Оценить",
        filterData: {
          title: "Ответьте на вопросы, и мы подберём идеального преподавателя",
          languageYouWantToLearn: "Язык, который вы хотите изучать",
          chooseLanguage: "Выберите язык",
          priceForLesson: "Стоимость урока",
          chooseQuality:
            "Выберите качество, которое вы больше всего цените в преподавателе",
        },
        showResult: "Показать результат",
        showMore: "Показать ещё ({value})",
      },
    },
    modules: {
      voiceRecorder: {
        title: "Диктофон",
      },
      cameraInitialization: {
        title: "Инициализация камеры",
      },
      cameraSettings: {
        title: "Настройки камеры",
        audio: "Аудио",
        video: "Видео",
        microphone: "Микрофон",
        camera: "Камера",
        preview: "Предпросмотр",
      },
    },
    camera: {
      cameraNotVisibleDescription:
        "Если вы не видите себя, измените устройство ввода камеры в настройках",
      cameraSettings: "Настройки камеры",
    },
    skills: {
      userCard: {
        perHour: "ч.",
        review: {
          hadNLessonsTogether:
            "не было уроков вместе | был {value} урок вместе | было {value} уроков вместе",
          noReviewsFound: "Нет отзывов об этом преподавателе",
        },
      },
      filters: {
        lessonPrice: "Стоимость урока",
        studyObjectives: "Цели обучения",
        form: {
          query: {
            label: "Имя",
            placeholder: "Введите имя преподавателя...",
          },
        },
      },
      noInstructorsFound: "Не найдено преподавателей по вашему запросу",
    },
    search: {
      title: "Поиск",
      tabs: {
        all: "Все",
        instructors: "Преподаватели",
        students: "Студенты",
      },
      filters: {
        interests: {
          label: "Интересы",
          placeholder: "Введите название интереса",
        },
        teaches: {
          label: "Преподаёт",
          placeholder: "Введите название языка",
        },
        speaks: {
          label: "Говорит",
          placeholder: "Введите название языка",
        },
        specialities: {
          label: "Специализации",
          placeholder: "Введите специализацию",
        },
        textbooks: {
          label: "Учебники",
          placeholder: "Введите название учебника",
        },
      },
    },
    signIn: {
      title: "Вход",
      yourEmail: "Ваш email",
      password: "Пароль",
      forgotYourPassword: "Забыли пароль?",
      signUpTitle: "Новый в Lingua Community?",
      signUp: "Зарегистрироваться",
      submit: "Войти",
    },
    signUp: {
      title: "Регистрация",
      header: "Выберите тип аккаунта",
      signInTitle: "Уже есть аккаунт?",
      signIn: "Войти",
      student: "Студент",
      instructor: "Преподаватель",
      form: {
        email: {
          label: "Email",
          placeholder: "Пример: example@mail.com",
        },
      },
    },
    restorePassword: {
      title: "Восстановление пароля",
      form: {
        email: {
          label: "Email",
          placeholder: "Пример: example@mail.com",
        },
        newPassword: {
          label: "Новый пароль",
          placeholder: "Введите новый пароль",
        },
      },
      submit: "Восстановить",
      rememberPasswordTitle: "Вспомнили пароль?",
      otpDescription: "Введите 6-значный код, отправленный на ваш email",
      newPasswordDescription: "Введите новый пароль",
      successDescription: "Пароль успешно изменён. Войдите с новым паролем",
      signIn: "Войти",
    },
    registration: {
      registerAs: "Зарегистрироваться как",
      student: "Студент",
      teacher: "Преподаватель",
      signUp: "Зарегистрироваться",
      login: "Войти",
      speak: "Говорю:",
      teach: "Преподаю:",
      learn: "Изучаю:",
      criteria: "Критерии:",
      specialities: "Специализации:",
      textbooks: "Учебники:",
      teachLabel: "Какой язык вы будете преподавать?",
      speakLabel: "На каких языках вы говорите?",
      learnLabel: "Какой язык вы будете изучать?",
      criteriaLabel: "Выберите критерии для преподавателя",
      user: {
        youRegisteredSuccessfully:
          "Вы успешно зарегистрированы. Проверьте email для дальнейших инструкций.",
        specialities: {
          learnBasics: "Основы",
          talkWithPeople: "Общение",
          forKids: "Для детей",
          improveProficiency: "Повышение уровня",
          doBusiness: "Для бизнеса",
          prepareForExam: "Подготовка к экзаменам",
        },
        studentReviewQuestions: {
          structure: {
            title: "Структура",
            shortTitle: "Структура",
            description:
              "Связаны ли уроки? Например, на первом уроке вы изучали модальный глагол «can» (I cannot help you). На следующем уроке - настоящее продолженное время (I am watching TV). В итоге вы комбинируете обе темы в предложениях типа “I cannot help you because I am watching TV”. Таким образом, структура - это не просто повторение, а интеграция предыдущей грамматики/лексики в новую тему, чтобы у студента не было пробелов.",
            optionsDescription:
              "1 – изучили тему и больше к ней не возвращались <br /> 5 – каждая новая тема объединяется с ранее изученной",
          },
          punctuality: {
            title: "Пунктуальность",
            shortTitle: "Пунктуальность",
            description:
              "В начале курса вы и преподаватель договорились о расписании. Вы могли согласовать регулярные встречи или плавающий график, а также политику отмены уроков. Важно, чтобы обе стороны чётко понимали и соблюдали договорённости.",
            optionsDescription:
              "1 – нет чётких договорённостей или вы крайне недовольны пунктуальностью преподавателя <br/> 5 – преподаватель соблюдает расписание и политику отмены",
          },
          capability: {
            title: "Компетентность",
            shortTitle: "Компетентность",
            description:
              "Насколько хорошо преподаватель знает предмет? Мы считаем, что хороший преподаватель должен знать немного больше, чем материалы учебника. Иначе вы могли бы изучить эти материалы самостоятельно с тем же успехом.",
            optionsDescription:
              "1  - Лучше бы учился сам <br/> 2 - преподаватель немного помогает <br/> 3  - преподаватель хорошо разбирается в материале, отвечает почти на все вопросы <br/> 4  - даёт дополнительную информацию, не указанную в учебнике (исключения, разные значения слов) <br/> 5 – делится культурными особенностями языка или разбирает языковые нюансы",
          },
          skills: {
            title: "Развитие навыков",
            shortTitle: "Навыки",
            description:
              "Уходите ли вы после урока с пустыми руками или приобретаете знания/навыки? Результат может быть небольшим, но измеримым шагом к достижению большей цели.",
            optionsDescription:
              "1 – потратили время впустую <br/> 5 – на каждом уроке приобретаете взаимосвязанные навыки, приближающие к цели",
          },
          practice: {
            title: "Практика",
            shortTitle: "Практика",
            description:
              "Какой язык чаще звучит на уроке: иностранный или родной?",
            optionsDescription:
              "1 – в основном родной язык <br/> 5 – только иностранный язык",
          },
          responsibility: {
            title: "Ответственность",
            shortTitle: "Ответственность",
            description:
              "Принимает ли преподаватель близко к сердцу ваши неудачи или успехи?",
            optionsDescription:
              "1 – преподаватель игнорирует трудности: если результаты плохие, виноват студент <br/> 5 – преподаватель переживает за результаты и адаптирует методику",
          },
          independence: {
            title: "Самостоятельность",
            shortTitle: "Самостоятельность",
            description:
              "Как преподаватель реагирует на ошибки? Сразу даёт правильный ответ или даёт возможность самостоятельно решить проблему?",
            optionsDescription:
              "1 – сразу исправляет (материала много, времени мало) <br/> 5 – подсказывает, но даёт время самостоятельно найти ответ",
          },
          allSkills: {
            title: "Развивает ли преподаватель все 5 навыков?",
            shortTitle: "Все навыки",
            description:
              "Идеально, когда каждый урок преподаватель уделяет равное внимание 5 языковым навыкам: аудирование, чтение, говорение, письмо, грамматика.",
            optionsDescription:
              "1 - фокусируется только на одном навыке <br /> 5. - развивает все 5 навыков",
          },
          timeManagement: {
            title: "Тайм-менеджмент",
            shortTitle: "Время",
            description: "Время урока используется мудро или тратится впустую?",
            optionsDescription:
              "1 – значительная часть времени тратится на действия, которые можно было сделать до урока (загрузка файлов, проверка посещаемости и т.д.) <br /> 5 – польза от каждой минуты урока",
          },
          listeningToStudent: {
            title: "Внимание к студенту",
            shortTitle: "Студентоцентричность",
            description:
              "Кто активнее на уроке: вы или преподаватель? Умеет ли преподаватель слушать?",
            optionsDescription:
              "1 – преподаватель не даёт возможности говорить <br /> 5 – преподаватель активно слушает студента",
          },
          approach: {
            title: "Подход",
            shortTitle: "Подход",
            description:
              "Кому-то нравятся авторитарные преподаватели, кому-то - демократичные. Нашёл ли ваш преподаватель правильный подход в общении?",
            optionsDescription:
              "1 – хотелось бы, чтобы преподаватель был мягче/строже <br /> 2 – преподаватель нашёл идеальный подход",
          },
        },
        userInterestGroup: {
          healthSport: {
            title: "Здоровье и спорт",
          },
          goingOutEntertainment: {
            title: "Отдых и развлечения",
          },
          hobbiesEducation: {
            title: "Хобби и образование",
          },
        },
        userInterest: {
          running: {
            title: "Бег",
          },
          workout: {
            title: "Тренировки",
          },
          volleyball: {
            title: "Волейбол",
          },
          cycling: {
            title: "Велоспорт",
          },
          chess: {
            title: "Шахматы",
          },
          martialArts: {
            title: "Боевые искусства",
          },
          basketball: {
            title: "Баскетбол",
          },
          football: {
            title: "Футбол",
          },
          hockey: {
            title: "Хоккей",
          },
          swimming: {
            title: "Плавание",
          },
          diving: {
            title: "Дайвинг",
          },
          extremeSports: {
            title: "Экстремальные виды спорта",
          },
          formula1: {
            title: "Формула 1",
          },
          meditation: {
            title: "Медитация",
          },
          yoga: {
            title: "Йога",
          },
          filmTv: {
            title: "Фильмы и ТВ",
          },
          theatre: {
            title: "Театр",
          },
          eatingOut: {
            title: "Рестораны",
          },
          museums: {
            title: "Музеи",
          },
          concerts: {
            title: "Концерты",
          },
          shopping: {
            title: "Шопинг",
          },
          gaming: {
            title: "Видеоигры",
          },
          boardGames: {
            title: "Настольные игры",
          },
          traveling: {
            title: "Путешествия",
          },
          hiking: {
            title: "Пеший туризм",
          },
          humor: {
            title: "Юмор",
          },
          business: {
            title: "Бизнес",
          },
          finance: {
            title: "Финансы",
          },
          management: {
            title: "Менеджмент",
          },
          music: {
            title: "Музыка",
          },
          space: {
            title: "Космос",
          },
          history: {
            title: "История",
          },
          pets: {
            title: "Домашние животные",
          },
          dancing: {
            title: "Танцы",
          },
          photography: {
            title: "Фотография",
          },
          singing: {
            title: "Пение",
          },
          arts: {
            title: "Искусство",
          },
          cars: {
            title: "Автомобили",
          },
          motorcycles: {
            title: "Мотоциклы",
          },
          cooking: {
            title: "Кулинария",
          },
          architecture: {
            title: "Архитектура",
          },
          reading: {
            title: "Чтение",
          },
          science: {
            title: "Наука",
          },
          psychology: {
            title: "Психология",
          },
          ecology: {
            title: "Экология",
          },
          technologies: {
            title: "Технологии",
          },
          fashion: {
            title: "Мода",
          },
          politics: {
            title: "Политика",
          },
          writing: {
            title: "Письмо",
          },
          design: {
            title: "Дизайн",
          },
          philosophy: {
            title: "Философия",
          },
          medicine: {
            title: "Медицина",
          },
          celebrities: {
            title: "Знаменитости",
          },
          volunteering: {
            title: "Волонтёрство",
          },
          news: {
            title: "Новости",
          },
          personalGrowth: {
            title: "Личностный рост",
          },
        },
        language: {
          english: {
            title: "Английский",
          },
          russian: {
            title: "Русский",
          },
          kyrgyz: {
            title: "Кыргызский",
          },
          kazakh: {
            title: "Казахский",
          },
          uzbek: {
            title: "Узбекский",
          },
          turkmen: {
            title: "Туркменский",
          },
          armenian: {
            title: "Армянский",
          },
        },
      },
    },
    passwordRecovery: {
      title: "Восстановление пароля",
      enterYourEmail: "Введите ваш email",
      rememberYourPassword: "Вспомнили пароль?",
      submit: "Отправить",
      instructionDescription:
        "Инструкция по восстановлению пароля отправлена на ваш email",
      goToLoginScreen: "Перейти к входу",
    },
    passwordRecoveryConfirmation: {
      title: "Подтверждение восстановления пароля",
      invalidResetTokenDescription:
        "Неверный токен восстановления. Попробуйте восстановить пароль снова",
      goToPasswordRecoveryScreen: "Перейти к восстановлению пароля",
      enterNewPassword: "Введите новый пароль",
      confirmYourNewPassword: "Подтвердите новый пароль",
      submit: "Изменить пароль",
      yourPasswordSuccessfullyChanged: "Пароль успешно изменён",
      goToLoginScreen: "Перейти к входу",
    },
    profile: {
      main: "Главная",
      feed: "Лента",
      messages: "Сообщения",
      notifications: "Уведомления",
      myConnections: "Мои связи",
      activityHistory: "История активности",
      schedule: "Расписание",
      myMaterials: "Мои материалы",
      savedMaterials: "Сохранённые материалы",
      lessonsHistory: "История уроков",
      quizzesHistory: "История тестов",
      detalization: "Детализация баланса",
      profileSettings: "Настройки профиля",
      photo: {
        title: "Фото профиля",
      },
      cover: {
        title: "Обложка профиля",
      },
      nConnections:
        "Нет связей | {value} связь | {value} связи | {value} связей",
      nStudents:
        "Нет студентов | {value} студент | {value} студента | {value} студентов",
      nInstructors:
        "Нет преподавателей | {value} преподаватель | {value} преподавателя | {value} преподавателей",
      connection: {
        connect: "Связаться",
        invited: "Приглашён",
        cancelInvitation: "Отменить приглашение",
        acceptInvitation: "Принять приглашение",
        ignore: "Игнорировать",
        connected: "Связан",
        removeConnection: "Удалить связь",
      },
      message: "Сообщение",
      connections: {
        title: "Связи",
        emptyDescription: "У вас пока нет связей",
      },
      about: {
        title: "О себе",
        teachingObjectives: "Цели преподавания",
        learningObjectives: "Цели обучения",
      },
      contactExchange: {
        title: "Запись на пробный урок",
        form: {
          telNumber: {
            placeholder: "+996 XXX YYY-YYY",
            hint: 'Отправляя данные, вы соглашаетесь с <a href="/terms-of-service" target="_blank">условиями использования</a>.',
          },
        },
        exchangeContacts: "Обмен контактами",
        modal: {
          informationSentSuccessfully: "Ваши данные отправлены преподавателю",
          callYourself: "Не хотите ждать? Позвоните сами",
          call: "Позвонить",
        },
      },
      prices: {
        title: "Цены",
        emptyDescription: "Вы ещё не указали цены",
        form: {
          title: {
            label: "Цена",
          },
        },
        addMore: "Добавить ещё",
      },
      publications: {
        shareYourExpertise: "Делитесь знаниями!",
        shareYourExpertiseDescription:
          "Вдохновляйте других, создавая и публикуя учебные материалы. Начните сейчас!",
        tabs: {
          posts: "Записи",
          materials: "Материалы",
        },
      },
      reputation: {
        title: "Репутация",
        overallTrust: "Общий рейтинг",
        basedOnNLessonsAndNTestimonials:
          "На основе {lessons} уроков и {testimonials} отзывов",
        whyYouCanTrustThisData: "Почему этим данным можно доверять?",
        startBuildingYourReputationDescription:
          "Проведите первый урок, чтобы начать формировать репутацию",
        reputationComingSoonDescription:
          "Этот преподаватель ещё не провёл достаточно уроков для формирования репутации",
      },
      reviews: {
        title: "Отзывы",
        title2: "Отзывы и достижения студентов",
        emptySelfDescription: "У вас пока нет отзывов",
        emptyDescription: "У пользователя пока нет отзывов",
        nReviews:
          "Нет отзывов | {value} отзыв | {value} отзыва | {value} отзывов",
        completedNLessons:
          "Не завершено уроков | Завершён {value} урок | Завершено {value} урока | Завершено {value} уроков",
        startCollectingTestimonialsDescription:
          "Попросите студентов оставлять отзывы после уроков, чтобы повысить доверие и привлечь новых учеников",
        noTestimonialsYet: "Пока нет отзывов",
        noTestimonialsYetDescription:
          "Этот преподаватель ещё не получил отзывов. Будьте первым!",
        whyYouCanTrustThisData: "Почему этим данным можно доверять?",
        readPrevious: "Предыдущий",
        readNext: "Следующий",
        seeUserAllTestimonials: "Все отзывы о {value}",
      },
      certificates: {
        title: "Дипломы и сертификаты",
        form: {
          title: {
            label: "Название",
            placeholder:
              "Пример: TOEFL iBT 83/120 [R. 22/30] [L. 28/30] [S. 30/30] [W. 24/30]",
          },
          organization: {
            label: "Организация",
            placeholder: "TOEFL Center - Бишкек",
          },
          issuedMonth: {
            label: "Дата выдачи",
            placeholder: "Месяц",
          },
          issuedYear: {
            placeholder: "Год",
          },
          credentialId: {
            label: "ID документа",
          },
          credentialUrl: {
            label: "Ссылка на документ",
          },
          media: "Медиа",
        },
        emptyDescription:
          "Покажите свои достижения! <br /> Добавьте сертификаты, чтобы улучшить профиль",
        deletionConfirmation: "Удалить этот сертификат?",
        item: {
          credentialId: "ID документа",
          issued: "Выдан",
          showDocument: "Показать документ",
          showCredential: "Показать документ",
        },
      },
      instructors: {
        title: "Преподаватели",
        nCount:
          "Нет преподавателей | {value} преподаватель | {value} преподавателя | {value} преподавателей",
        emptyDescription: "Преподаватели не найдены",
      },
      students: {
        title: "Студенты",
        nCount:
          "Нет студентов | {value} студент | {value} студента | {value} студентов",
        emptyDescription: "Студенты не найдены",
      },
      edit: {
        name: {
          title: "Имя",
        },
        about: {
          title: "О себе",
          form: {
            longAbout: {
              placeholder: "Расскажите о своём опыте, достижениях и т.д.",
            },
          },
        },
        profilePhoto: {
          title: "Фото профиля",
          instructorDescription: `Лица вызывают доверие, а не логотипы. Добавьте фото для укрепления профессионального бренда.`,
          studentDescription: `Добавьте фото — так вас будет проще узнать`,
        },
        contacts: {
          title: "Контакты",
          instructorDescription: `Каждый заслуживает прямого общения. Обменивайтесь контактами со студентами через удобную форму.`,
          studentDescription: `Могут ли с вами связаться по телефону?`,
        },
        aboutYou: {
          title: "О вас",
          instructorDescription: `Опишите вашего идеального студента. Почему вам нравится работать с такими студентами? <br> Чего вы можете достичь вместе?`,
          studentDescription: `Расскажите, откуда вы и/или что вам интересно`,
        },
        headline: {
          title: "Заголовок",
          instructorDescription: `Заголовок будет отображаться в профиле и поможет другим понять ваш опыт`,
          studentDescription: `Опишите цели обучения`,
        },
        teachingObjectives: {
          title: "Цели преподавания",
          description: "С чем вы помогли вашему идеальному студенту?",
        },
        learningObjectives: {
          title: "Цели обучения",
          description: "Для каких целей вы изучаете языки?",
        },
        teachingLanguage: {
          title: "Преподаваемый язык",
          description: "Язык, на котором вы преподаёте",
        },
        learningLanguage: {
          title: "Изучаемый язык",
          description: "Язык, который вы изучаете",
        },
        speakingLanguages: {
          title: "Изучаемый язык",
          description: "Язык, который вы изучаете",
        },
        email: {
          title: "Email",
          verificationSentDescription: `Код подтверждения отправлен на {email}. Проверьте почту и введите код`,
          changeEmail: "Изменить email",
        },
        password: {
          title: "Изменить пароль",
        },
        form: {
          common: {
            firstName: {
              label: "Имя",
              placeholder: "Иван",
            },
            lastName: {
              label: "Фамилия",
              placeholder: "Иванов",
            },
            languageLevel: {
              label: "Уровень",
            },
            speakLanguages: {
              label: "Языки, на которых вы говорите",
            },
            oldPassword: {
              label: "Старый пароль",
            },
            newPassword: {
              label: "Новый пароль",
              placeholder: "Введите пароль",
            },
            password: {
              label: "Пароль",
              placeholder: "Введите пароль",
            },
            repeatPassword: {
              label: "Повторите пароль",
              placeholder: "Повторите пароль",
            },
            currentEmail: {
              label: "Текущий email",
            },
            newEmail: {
              label: "Новый email",
            },
          },
          instructor: {
            telNumber: {
              label: "Телефон",
              placeholder: "+996 XXX YYY-YYY",
            },
            showOnRecommendationPage: {
              label: "Помочь найти студентов",
            },
            content: {
              placeholder:
                "Мой идеальный студент — школьник, готовящийся к поступлению в вуз мечты. Я помогу ему сдать IELTS.",
            },
            shortAbout: {
              label: "Заголовок",
              placeholder:
                "Пример: Сертифицированный преподаватель английского | IELTS 8.5 | CELTA",
            },
            specialities: {
              label: "Цели преподавания",
              hint: "Выберите не более 3 категорий",
            },
            targetLanguage: {
              label: "Преподаваемый язык",
            },
          },
          student: {
            telNumber: {
              label: "Телефон",
              placeholder: "+996 XXX YYY-YYY",
            },
            showOnRecommendationPage: {
              label: "Помочь найти преподавателя",
            },
            content: {
              placeholder:
                "Пример: Я из небольшого города в Кыргызстане. Готовлюсь к IELTS 6 месяцев и уже есть прогресс. Хочу поступить в университет США на полную стипендию.",
            },
            shortAbout: {
              label: "Заголовок",
              placeholder:
                "Пример: Мечтаю свободно общаться в путешествиях по США",
            },
            specialities: {
              label: "Цели обучения",
              hint: "Выберите не более 3 категорий",
            },
            targetLanguage: {
              label: "Изучаемый язык",
            },
          },
        },
      },
      quickProfileUpdate: {
        title: "Обновление профиля",
        updateSuccess:
          "Информация добавлена в профиль. При необходимости вы можете её изменить.",
        letsStart: "Начнём",
        instructor: {
          description:
            "Ответьте на несколько вопросов, чтобы настроить профиль и найти идеального студента",
        },
        student: {
          description:
            "Зачем учиться в одиночку? Присоединяйтесь к сообществу.",
        },
      },
    },
    notifications: {
      notificationsManagement: "Управление уведомлениями",
      tabs: {
        all: {
          short: "Все",
          long: "Все уведомления",
        },
        lesson: {
          short: "Уроки",
          long: "Уведомления об уроках",
        },
        other: {
          short: "Прочие",
          long: "Прочие уведомления",
        },
      },
    },
    lessons: {
      lessonsManagement: "Управление уроками",
      upcomingLessons: "Предстоящие уроки",
      pastLessons: "Прошедшие уроки",
      newLesson: "Новый урок",
      startInstantLesson: "Начать мгновенный урок",
      scheduleLesson: "Запланировать урок",
      currentLessons: "Текущие уроки",
      emptyStartingLessonsInstructor:
        "У вас нет уроков, начинающихся в ближайшее время. Но есть запланированные уроки! <br> Вы можете начать мгновенный урок или запланировать новый",
      emptyStartingLessonsStudent:
        "У вас нет уроков, начинающихся в ближайшее время. Проверьте расписание или свяжитесь с преподавателем",
      scheduledItem: {
        noParticipants: "Нет участников",
        andNParticipants:
          "нет участников | и {value} участник | и {value} участника | и {value} участников",
        live: "в прямом эфире",
        details: "Детали",
        lessonWasCancelled: "Урок отменён",
        reason: "Причина",
        preview: "Предпросмотр",
        joinNow: "Присоединиться",
        reschedule: "Перенести",
        cancel: "Отменить",
        teacher: "Преподаватель",
        students: "Студент(ы)",
        userXLeftLessonAt: "{userFullName} покинул(а) урок в {time}",
        userXCancelledLessonAt: "{userFullName} отменил(а) урок в {time}",
      },
      schedule: {
        title: "Планирование урока",
        editParticipants: "Изменить участников",
        additionalSettings: "Дополнительные настройки",
        participants: "Участники",
        emptyParticipants: "Участники не добавлены. Добавьте участников",
        addParticipants: "Добавить участников",
        form: {
          title: {
            label: "Название",
          },
          startsAt: {
            label: "Начало урока",
          },
          duration: {
            label: "Продолжительность",
            items: {
              "30min": "30 мин.",
              "45min": "45 мин.",
              "1hour": "1 час",
              "1halfHours": "1.5 часа",
              "2hours": "2 часа",
            },
          },
          lessons: {
            label: "Уроки",
            placeholder: "Поиск уроков",
            rules: {
              required: "Выберите хотя бы один урок",
            },
          },
          quizzes: {
            label: "Тест",
            placeholder: "Поиск тестов",
            rules: {
              required: "Выберите хотя бы один тест",
            },
          },
          students: {
            label: "Студенты",
            placeholder: "Поиск по вашим связям",
            rules: {
              required: "Выберите хотя бы одного студента",
            },
          },
          price: {
            label: "Цена",
            rules: {
              required: "Укажите положительное число",
            },
          },
          commonPrice: {
            label: "Общая цена",
          },
          notes: {
            label: "Заметки",
          },
        },
      },
      cancelSchedule: {
        title: "Отмена запланированного урока",
        form: {
          reason: {
            label: "Причина",
            placeholder:
              "Укажите причину отмены урока (например, конфликт расписания, непредвиденные обстоятельства)",
          },
        },
      },
      selectUsers: {
        title: "Выберите пользователей для урока",
      },
    },
    main: {
      endOfActivities: "Конец активности",
      noActivities: "Нет активности",
      previewAlert: {
        title: "Предпросмотр профиля",
        description: "Вы можете посмотреть предпросмотр профиля",
        button: "Мой профиль",
      },
    },
    myConnections: {
      networkManagement: "Управление сетью",
      invitations: "Приглашения",
      myInvitations: "Мои приглашения",
      myConnections: "Мои связи",
      userConnections: "Связи пользователя",
      noConnectionsYet: "У вас пока нет связей",
      noConnectionFoundForYourRequest: "По вашему запросу связи не найдены",
      pendingSharedContacts: "Ожидающие контакты",
      noPendingSharedContacts: "Нет ожидающих контактов",
      markAsRead: "Пометить прочитанным",
      manageSharedContacts: "Управление контактами",
      pendingInvitations: "Ожидающие приглашения",
      manageInvitations: "Управление приглашениями",
      manageMyConnections: "Управление моими связями",
      noPendingInvitations: "Нет ожидающих приглашений",
    },
    preferences: {
      title: "Настройки",
      account: {
        title: "Настройки аккаунта",
        groups: {
          profileInformation: {
            title: "Информация профиля",
            items: {
              name: "Имя",
              contact: "Контакты",
              headline: "Заголовок",
              about: "О себе",
              teachingObjectives: "Цели преподавания",
              learningObjectives: "Цели обучения",
              teachingLanguage: "Преподаваемый язык",
              learningLanguage: "Изучаемый язык",
              speakingLanguages: "Языки общения",
            },
          },
        },
      },
      signInAndSecurity: {
        title: "Вход и безопасность",
        groups: {
          security: {
            title: "Безопасность",
            items: {
              email: "Email",
              password: "Изменить пароль",
            },
          },
        },
      },
      logout: {
        title: "Выйти",
      },
    },
    userConnections: {
      title: "Связи пользователя",
    },
    logout: {
      loggingOut: "Выход...",
    },
    detalization: {
      title: "Детализация баланса",
      dateRange: "Период",
      type: "Тип",
      createdAt: "Создано",
      in: "Входящие",
      out: "Исходящие",
      balanceBefore: "Баланс до",
      balanceAfter: "Баланс после",
      sum: "Сумма",
      noHistoryFound: "Нет операций",
    },
    activityHistory: {
      title: "История активности",
      groupedItemTitle: {
        today: "Сегодня",
        yesterday: "Вчера",
        thisWeek: "На этой неделе",
        thisMonth: "В этом месяце",
        thisYear: "В этом году",
        earlier: "Ранее",
      },
      createdLesson: "Создан урок",
      scheduledLesson: "Запланирован урок",
      startedLesson: "Начат урок",
      with: "с",
      createdQuiz: "Создан тест",
      finishedQuiz: "Завершён тест",
      and: "и",
    },
    materials: {
      materials: "Материалы",
      tabs: {
        lessons: "Уроки",
        quizzes: "Тесты",
        fileManager: "Файловый менеджер",
      },
      savedMaterials: "Сохранённые материалы",
      author: "Автор",
      whiteboard: "Доска",
      myMaterials: "Мои материалы",
      title: "Название",
      createdAt: "Создано",
      actions: "Действия",
      details: "Детали",
      creating: "Создание",
      updating: "Обновление",
      choose: "Выбрать",
      attachmentDeletionConfirmation: "Удалить это вложение?",
      audioDeletionConfirmation: "Удалить это аудио?",
      description: "Описание",
      notes: "Заметки",
      mainInfo: "Основная информация",
      audio: "Аудио",
      attachments: "Вложения",
      vocabulary: "Словарь",
      asVocabulary: "Только как словарь",
      itemsPerPage: "Заданий на страницу",
      points: "Баллы",
      user: "Пользователь",
      nonRegisteredUser: "Незарегистрированный пользователь",
      nonRegisteredUserTelNumber: "Телефон незарегистрированного пользователя",
      backToMain: "На главную",
      backToLessons: "К урокам",
      lesson: {
        title: "Урок",
        tabs: {
          main: {
            title: "Основное",
          },
          attachments: {
            title: "Вложения",
            tabs: {
              audio: "Аудио",
              documents: "Документы",
              "board-documents": "Документы доски",
            },
          },
          exercises: {
            title: "Задания",
            tabs: {
              vocabulary: "Словарь",
              exercises: "Задания",
            },
          },
          whiteboard: {
            title: "Доска",
          },
        },
        form: {
          title: {
            label: "Название",
          },
          category: {
            label: "Категория",
          },
        },
        sharingSettings: {
          title: "Настройки доступа",
        },
      },
      lessons: {
        all: "Все",
        owned: "Созданные",
        forked: "Сохранённые",
        lessonsList: "Список уроков",
        lessons: "Уроки",
        duration: "Продолжительность",
        myLessons: "Мои уроки",
        newLesson: "Новый урок",
        deletionConfirmation: "Удалить этот урок?",
        filters: "Фильтры",
        authorizeToAccessBoard:
          "Доска недоступна незарегистрированным пользователям. Войдите в систему",
        noLessonsFound: "Уроки не найдены",
        noDescriptionAddedYet: "Описание урока пока не добавлено",
        addDescription: "Добавить описание",
        editDescription: "Редактировать описание",
      },
      quiz: {
        title: "Тест",
        exercisesPerPageHint: "0 - все задания на одной странице",
        tabs: {
          edit: {
            title: "Редактировать",
          },
          main: {
            title: "Основное",
          },
          history: {
            title: "История",
          },
        },
        types: {
          exercise: {
            title: "Задание",
          },
          vocabulary: {
            title: "Словарь",
          },
        },
        form: {
          title: {
            label: "Название",
          },
          category: {
            label: "Категория",
          },
        },
        sharingSettings: {
          title: "Настройки доступа",
        },
        additionalSettings: {
          title: "Дополнительные настройки",
        },
      },
      quizzes: {
        all: "Все",
        owned: "Созданные",
        forked: "Сохранённые",
        quizzesList: "Список тестов",
        details: "Детали",
        backToQuiz: "Назад к тесту",
        backToHistory: "Назад к истории",
        numberOfExercises: "Количество заданий",
        maxPoints: "Макс. баллов",
        quizzes: "Тесты",
        myQuizzes: "Мои тесты",
        history: "История",
        linkedQuizzes: "Связанные тесты",
        linkedVocabulary: "Связанные словари",
        newQuiz: "Новый тест",
        linking: "Связывание",
        quiz: "тест",
        quizUF: "Тест",
        vocabulary: "словарь",
        deletionConfirmation: "Удалить этот тест?",
        unlinkConfirmation: "Отвязать этот тест?",
        navigation: "НАВИГАЦИЯ",
        filters: "Фильтры",
        student: "Студент",
        setFlag: "Пометить",
        unsetFlag: "Снять пометку",
        submitConfirmation: "Отправить тест?",
        noAnswerExercises: "У вас есть невыполненные задания",
        weAreSorryQuizNotFound: "Извините, тест не найден :(",
        nonRegistered: {
          title: "Предоставьте информацию",
          fullName: "Полное имя",
          telNumber: "Телефон",
        },
        allUsers: "Все пользователи",
        registeredUsers: "Зарегистрированные",
        nonRegisteredUsers: "Незарегистрированные",
        self: "Свои",
        noDescriptionAddedYet: "Описание теста пока не добавлено",
        addDescription: "Добавить описание",
        editDescription: "Редактировать описание",
        editAdditionalSettings: "Редактировать доп. настройки",
        authorizeToAccessHistory:
          "История недоступна. Войдите для сохранения результатов",
        noQuizzesFound: "Тесты не найдены",
        noQuizHistoriesFound: "Истории тестов не найдены",
      },
      exercises: {
        exercises: "Задания",
        exercise: "Задание",
        noAnyExercises: "Нет заданий",
        noAnyVocabulary: "Нет словарей",
        noAnswer: "Нет ответа",
        detailsAreNotAvailable:
          "Детали недоступны, так как автор изменил задание после вашей отправки",
        types: {
          dragTheWords: {
            title: "Перетащи слова",
            adminDescription: "Описание для преподавателя",
            studentDescription: "Описание для студента",
            draggable: "Перетаскиваемое",
            markSelected: "Пометить как перетаскиваемое",
            unmarkSelected: "Снять пометку",
          },
          dragTheWordsImage: {
            title: "Перетащи слова (изображение)",
            adminDescription: "Описание для преподавателя",
            studentDescription: "Описание для студента",
            draggable: "Перетаскиваемое",
            markSelected: "Пометить как перетаскиваемое",
            unmarkSelected: "Снять пометку",
          },
          fillInTheBlanks: {
            title: "Заполни пропуски",
            adminDescription: "Описание для преподавателя",
            studentDescription: "Описание для студента",
            or: "Или",
            anyChar: "Любой символ",
            anyText: "Любой текст",
            addAnotherOption: "Добавить вариант",
            markSelected: "Пометить как поле",
            unmarkSelected: "Снять пометку",
            field: "Поле",
          },
          fillInTheBlanksImage: {
            title: "Заполни пропуски (изображение)",
            adminDescription: "Описание для преподавателя",
            studentDescription: "Описание для студента",
            or: "Или",
            anyChar: "Любой символ",
            anyText: "Любой текст",
            addAnotherOption: "Добавить вариант",
            markSelected: "Пометить как поле",
            unmarkSelected: "Снять пометку",
            field: "Поле",
          },
          findSynonym: {
            title: "Найди синоним",
            adminDescription: "Описание для преподавателя",
            studentDescription: "Описание для студента",
            markMainSynonymSelected: "Пометить как основной синоним",
            markRealSynonymSelected: "Пометить как настоящий синоним",
            markFakeSynonymSelected: "Пометить как ложный синоним",
            unmarkSelected: "Снять пометку",
            synonym: "Синоним",
            real: "Настоящий",
            fake: "Ложный",
          },
          findThePlace: {
            title: "Найди место",
            adminDescription: "Описание для преподавателя",
            studentDescription: "Описание для студента",
            real: "Настоящее",
            fake: "Ложное",
            insertFakePlace: "Добавить ложное место",
            markRealPlaceSelected: "Пометить как настоящее место",
            unmarkSelected: "Снять пометку",
          },
          markTheWords: {
            title: "Пометь слова",
            adminDescription: "Описание для преподавателя",
            studentDescription: "Описание для студента",
            correct: "Правильно",
            wrong: "Неправильно",
            markCorrectSelected: "Пометить как правильное",
            markWrongSelected: "Пометить как неправильное",
            unmarkSelected: "Снять пометку",
          },
          multipleChoice: {
            title: "Множественный выбор",
            adminDescription: "Описание для преподавателя",
            studentDescription: "Описание для студента",
          },
          singleChoice: {
            title: "Одиночный выбор",
            adminDescription: "Описание для преподавателя",
            studentDescription: "Описание для студента",
          },
          trueFalse: {
            title: "Верно/Неверно",
            adminDescription: "Описание для преподавателя",
            studentDescription: "Описание для студента",
          },
        },
        true: "Верно",
        false: "Неверно",
        answer: "Ответ",
        title: "Название",
        type: "Тип",
        description: "Описание",
        text: "Текст",
        chooseImage: "Выбрать изображение",
        descriptionAudio: "Аудиоописание",
        answerAudio: "Аудиоответ",
        attachedAudio: "Прикреплённое аудио",
        audioHint:
          "Работает, если в настройках теста указано 1 задание на страницу",
        hideAudio: "Скрыть аудио",
        audioAutoplay: "Автовоспроизведение",
        answerOptions: "Варианты ответа",
        selectCorrectAnswers: "Выберите правильные ответы",
        selectCorrectAnswer: "Выберите правильный ответ",
        errorHint: "Подсказка при ошибке",
        addOption: "Добавить вариант",
        deletionConfirmation: "Удалить это задание?",
        total: "Всего",
        nExercises: "{count} задание | {count} задания | {count} заданий",
        nVocabularies: "{count} словарь | {count} словаря | {count} словарей",
        nPoints: "{count} балл | {count} балла | {count} баллов",
        addExercise: "Добавить задание",
        selectExerciseType: "Выберите тип задания",
        newVocabulary: "Новый словарь",
        linkExercisesFromQuiz: "Связать задания из теста",
        linkVocabulary: "Связать словарь",
        searchLabel: "Поиск: название, тип",
        points: "Баллы",
        createdAt: "создано {createdAt}",
        goBack: "Назад",
        creating: "Создание",
        editing: "Редактирование",
        showCorrectnessOnError: "Показывать правильность после проверки",
        countPartialPts: "Начислять частичные баллы",
        nOfxPts: "<b>{count}</b> из <b>{points}</b> баллов",
        upload: "Загрузить",
        record: "Записать",
        audioNotSelectedOrRecorded: "Аудио не выбрано или не записано",
        preview: "Предпросмотр",
      },
      privacy: {
        privacy: "Доступ",
        public: "Публичный",
        publicDescription: "Виден всем",
        hidden: "Скрытый",
        hiddenDescription: "Виден только автору",
        scheduled: "По расписанию",
        scheduledDescription: `Доступен с указанной даты в течение 3 дней`,
        forConnections: "Для связей",
        forConnectionsDescription: `Виден только связям автора`,
      },
      publication: {
        form: {
          title: {
            placeholder: "Название",
          },
          level: {
            label: "Уровень",
          },
          description: {
            placeholder: "Описание",
          },
        },
        selectFromMyOwnMaterials: "Выбрать из моих материалов",
        publicationIsEmpty: "Публикация пуста",
        selectUsersToSend: "Выберите пользователей для отправки",
        repostDescription: {
          repost: "Мгновенно поделиться публикацией",
          repostWithYourThoughts:
            "Создать новую запись на основе этой публикации",
        },
        copyLinkToPublication: "Копировать ссылку на публикацию",
        section: {
          generatedTitle: "Раздел #{value}",
          deletionConfirmation: "Удалить этот раздел?",
          addSection: "Добавить раздел",
          sectionIsEmpty: "Раздел пока пуст",
          addResource: "Добавить ресурс",
          selectResourceType: "Выберите тип ресурса",
          resource: {
            form: {
              content: {
                placeholder: "Содержание ресурса...",
              },
            },
            deletionConfirmation: "Удалить этот ресурс?",
            copyLinkToResource: "Копировать ссылку на ресурс",
            selectUsersToSend: "Выберите пользователей для отправки",
            groups: {
              interactivity: {
                title: "Интерактивность",
              },
              mediaAssets: {
                title: "Медиа",
                items: {
                  media: "Изображение / Видео",
                  audio: "Аудио",
                  text: "Текст",
                },
              },
            },
            repostDescription: {
              repost: "Мгновенно поделиться ресурсом",
              repostWithYourThoughts: "Создать новую запись на основе ресурса",
            },
          },
        },
        searchForAnyMaterial: "Поиск материалов",
        own: "Свои",
        common: "Общие",
        noPublicationsFound: "Публикации не найдены",
        noSavedPublicationsFound: "Сохранённые публикации не найдены",
        createPublication: "Создать публикацию",
        commonPublications: "Общие публикации",
        myPublications: "Мои публикации",
        savedPublications: "Сохранённые публикации",
        allMyPublications: "Все мои публикации",
        allSavedPublications: "Все сохранённые публикации",
      },
    },
    messages: {
      title: "Сообщения",
      selectContacts: {
        title: "Выберите пользователя для чата",
      },
      chat: {
        title: "Чат",
        search: "Поиск...",
        writeMessage: "Написать сообщение...",
        typeToMessage: "Введите сообщение",
        endMessage: "Это конец сообщений",
        youDontHaveAnyChat: "У вас пока нет чатов",
        startChattingDescription: "Начните чат, выбрав кого-то из ваших связей",
        startChatting: "Начать чат",
        send: "Отправить",
        connections: {
          title: "Связи",
        },
      },
    },
    lessonBoards: {
      myLessonBoards: "Мои доски уроков",
      createLessonBoard: "Создать доску",
      noLessonBoardsFound: "Доски не найдены",
    },
    profileSettings: {
      title: "Настройки профиля",
      editingProfile: "Редактирование профиля",
      basicInfo: "Основная информация",
      aboutProfile: "О профиле",
      balanceDetalization: "Детализация баланса",
      backToProfileSettings: "Назад к настройкам профиля",
      interests: "Интересы и хобби",
      textbooks: "Учебники",
      prices: "Цены",
      additionalInfo: "Дополнительная информация",
      mainInfo: "Основная информация",
      firstName: "Имя",
      lastName: "Фамилия",
      email: "Email",
      phoneNumber: "Телефон",
      profilePhoto: "Изменить фото",
      buttonContinue: "Продолжить",
      showOnRecommendationPage: "Показывать на странице рекомендаций",
      shortAbout: "Кратко о себе",
      longAbout: "О себе",
      shortAboutHint: "Кратко опишите себя",
      longAboutHint: "Расскажите о себе",
      buttonSave: "Сохранить",
      buttonPrevious: "Назад",
      pricesTab: {
        title: "Название",
        addMore: "Добавить ещё",
        emptyDescription: "Вы ещё не указали цены",
      },
    },
    userProfile: {
      about: "О себе",
      wasOnline: "Был(а) в сети:",
      teaches: "Преподаёт:",
      speaks: "Говорит:",
      specialities: "Специализации:",
      textbooks: "Учебники:",
      interests: "Интересы:",
      learns: "Изучает:",
      prices: "Цены",
      priceTable: {
        title: "Название",
        price: "Цена (за час)",
      },
      mustRate: "Вы должны оценить по каждому критерию",
      leaveThoughts: "Оставьте отзыв о преподавателе",
      reviewComponentTitle: "Пожалуйста, оцените работу преподавателя",
      reviews: "Отзывы",
      edit: {
        userAbout: {
          form: {
            longAbout: {
              placeholder: "Расскажите о своём опыте, достижениях и т.д.",
            },
          },
        },
        certificate: {
          form: {
            title: {
              label: "Название",
              placeholder:
                "Пример: TOEFL iBT 83/120 [R. 22/30] [L. 28/30] [S. 30/30] [W. 24/30]",
            },
            organization: {
              label: "Организация",
              placeholder: "TOEFL Center - Бишкек",
            },
            issuedMonth: {
              label: "Дата выдачи",
              placeholder: "Месяц",
            },
            issuedYear: {
              placeholder: "Год",
            },
            credentialId: {
              label: "ID документа",
            },
            credentialUrl: {
              label: "Ссылка на документ",
            },
            media: "Медиа",
          },
        },
      },
    },
    schedule: {
      title: "Расписание",
      plannedLesson: "Запланированный урок",
      start: "Начало",
      lessonWith: "Урок с {instructorFirstName} {instructorLastName}",
      deleteConfirmation: "Удалить план урока?",
      today: "Сегодня",
      day: "День",
      week: "Неделя",
      month: "Месяц",
      "4days": "4 дня",
      createLessonSchedule: "Планирование нового урока",
      updateLessonSchedule: "Обновление расписания",
      startNow: "Начать сейчас",
      schedule: "Расписание",
      calendarCard: {
        title: "Название",
        plannedDate: "Дата",
        lessons: "Уроки",
        students: "Студенты",
        notes: "Заметки",
      },
      history: "История",
    },
    liveLesson: {
      tabs: {
        main: {
          title: "Основное",
        },
        attachments: {
          title: "Вложения",
          tabs: {
            audio: "Аудио",
            documents: "Документы",
            "board-documents": "Документы доски",
          },
        },
        exercises: {
          title: "Задания",
          tabs: {
            vocabulary: "Словарь",
            exercises: "Задания",
          },
        },
        whiteboard: {
          title: "Доска",
        },
        chat: {
          title: "Чат",
        },
        live: {
          title: "Эфир",
        },
        material: {
          title: "Материал",
        },
      },
      lesson: "Урок",
      currentLiveScheduledLessons: "Текущие уроки в эфире",
      upcomingScheduledLessons: "Предстоящие уроки",
      noUpcomingSchedules: {
        title: "Нет предстоящих событий",
        description: "У вас нет запланированных уроков",
      },
      attachments: {
        editAttachments: "Редактировать вложения",
        lessonAttachments: "Вложения урока",
        boardAttachments: "Вложения доски",
        noLessonAttachmentsAddedYet: "Вложений урока пока нет",
        noLessonAudiosAddedYet: "Аудио урока пока нет",
        noBoardAttachmentsAddedYet: "Вложений доски пока нет",
      },
      live: {
        title: "Эфир",
        join: "Присоединиться",
        videoIsNotAvailable: "Видео недоступно",
        you: "Вы",
        lessonIsOver: "Урок завершён",
        lessonNotStarted: "Урок ещё не начался",
        readyToJoin: "Готовы присоединиться?",
        youHaveNotJoinedYet: "Вы ещё не присоединились. Хотите присоединиться?",
        lessonScheduledInfo:
          "Урок запланирован на <b>{lessonStartsAt} - {lessonEndsAt}</b>",
        tooEarlyToJoin:
          "Ваш урок начнётся в {lessonStartsTime} {lessonStartsDate}. <br /> Ваше местное время: {localTime} {localDate}.",
        tooLateToJoin:
          "Ваш урок прошёл с {lessonStartsTime} до {lessonEndsTime} {lessonEndsDate}. <br /> Ваше местное время: {localTime} {localDate}.",
      },
      board: {
        noBoardsCreatedYetInstructor:
          "Досок уроков не создано. Хотите создать?",
        noBoardsCreatedYetStudent:
          "Досок уроков не создано. Попросите преподавателя создать",
        add: {
          title: "Создание доски",
          boardName: {
            label: "Название доски",
            placeholder: "Введите название",
          },
          cloneFrom: {
            title: "Клонировать из",
            lessonBoards: "Доски уроков",
            latestBoards: "Последние доски",
            boardsWithCurrentStudents: "Доски с текущими студентами:",
          },
        },
        lock: "Заблокировать",
        sync: "Синхронизировать",
        additionalOptions: "Дополнительные опции",
        borderStyleOpacityAndColor: "Стиль, прозрачность и цвет границы",
        colorAndOpacity: "Цвет и прозрачность",
        color: "Цвет",
        bringToFront: "На передний план",
        bringForward: "Переместить вперёд",
        sendToBack: "На задний план",
        sendBackward: "Переместить назад",
        image: "Изображение",
        video: "Видео",
        audio: "Аудио",
        document: "Документ",
        fromYourDevice: "С устройства",
        pasteDirectUrl: "Вставить прямую ссылку",
        yourVideoUrl: "Ссылка на видео",
        pasteViaYouTubeUrl: "Вставить ссылку YouTube",
        youTubeVideoUrl: "Ссылка YouTube",
      },
      audio: {
        addAudio: "Добавить аудио",
        editAudio: "Редактировать аудио",
      },
      attachment: {
        add: "Добавить вложения",
        edit: "Редактировать вложения",
      },
      exercise: {
        addExercises: "Добавить задания",
        editExercises: "Редактировать задания",
        noLessonExercisesAttachedYet: "Задания урока пока не добавлены",
      },
      vocabulary: {
        addVocabulary: "Добавить словарь",
        editVocabulary: "Редактировать словарь",
        noLessonVocabularyAttachedYet: "Словари урока пока не добавлены",
      },
      chat: {
        typeSomething: "Введите сообщение...",
      },
      noAnyLessonAddedYet: "Уроки пока не добавлены",
      addLesson: "Добавить урок",
      authRequired: "Требуется авторизация",
      authRequiredDescription:
        "Войдите или создайте аккаунт для участия в уроке",
    },
    accessDenied: {
      title: "Доступ запрещён",
    },
    pageNotFound: {
      title: "Страница не найдена",
    },
    externalLink: {
      description: "Вы переходите по ссылке...",
    },
    landing: {
      greeting: "Здравствуйте",
      howItWorks: "Как это работает?",
      findTeacher: "Найти преподавателя",
      advantages: "Преимущества",
      prices: "Цены",
      socialPlatform: "Социальная платформа для изучения языков",
      hereSuccess: "Здесь успешные студенты рекомендуют своих преподавателей.",
      register: "Регистрация / Вход",
      findATeacher: "Найти преподавателя",
      magicStarts:
        "Настоящее волшебство начинается, когда мы признаём тех, кто стоит за нашим успехом.",
      heroAddress: "Акилай Мисс Кыргызстан 2023 ",
      dontRisk:
        "Не рискуйте, не доверяйте рекламе. Доверяйте людям. Спрашивайте людей.",
      weOffer:
        "Мы предлагаем простые инструменты для оценки профессиональных качеств преподавателей.",
      supportedByLocal: "Поддержка местных инфлюенсеров",
      criteria: "6 критериев ",
      assessTeachers: "Для оценки преподавателей",
      freeForStudents: "Платформа бесплатна для студентов",
      realTestimonials: "Реальные отзывы и рекомендации от реальных людей",
      weHelp: "Мы помогаем",
      students: "Студентам",
      toFindIdealTeacher:
        "Найти идеального преподавателя на основе независимой оценки сообщества.",
      teachers: "Преподавателям",
      toDevelop: "Развивать личный бренд профессионального преподавателя.",
      seeHowItWork: "Посмотрите, как это работает",
      choosingATeacher: "Выбор преподавателя",
      lessonRoutine: "Оценка профессиональных качеств",
      independentAssessment: "Независимая оценка",
      communityIndependent: "Независимая оценка сообщества",
      howToChoose: "Как выбрать преподавателя",
      findYourIdealTeacher:
        "Найдите идеального преподавателя по рейтингам: пунктуальность, компетентность и т.д.",
      findYourIdealTeacher2:
        "Вы также можете искать по специализации (бизнес, IT, академический язык и т.д.)",
      ourQualityControl: "Контроль качества",
      theLessonsAreConducted:
        "Уроки проходят на нашей платформе для сбора реальных отзывов.",
      inAddition:
        "Кроме того, платформа удобна. Всё необходимое для преподавателя или студента в одном месте: материалы, планы уроков, интерактивные задания, видеозвонки, онлайн-доска и т.д.",
      testimonialsAfterLesson: "Отзывы после урока",
      byTheEndOf:
        "В конце урока появляется окно для отзыва. Чем больше уроков у студента, тем больше его оценка влияет на рейтинг преподавателя.",
      exampleProfile: "Пример профиля преподавателя.",
      aboutMe: "Обо мне",
      myStudentsReach:
        "Мои студенты достигают целей. Мои рейтинги подтверждают мою репутацию компетентного и строгого преподавателя.",
      education: "Образование",
      americanUniversity: "Американский университет в Центральной Азии",
      certificates: "Сертификаты",
      testimonials: "Отзывы",
      readMore: "Читать далее",
      provenCapability: "Компетентность",
      strictness: "Строгость",
      punctuality: "Пунктуальность",
      overallLessons: "Всего уроков",
      skillsDeveloped: "Развитие навыков",
      lessonPrice: "за урок",
      yourPhone: "Ваш телефон",
      yourContact: "Ваши данные отправлены преподавателю",
      yourContact2: "Не хотите ждать? Позвоните сами.",
      bySending: "Отправляя данные, вы соглашаетесь с условиями использования.",
      exchangeContacts: "Обмен контактами",
      call: "Позвонить",
      completedLesson: "10 уроков завершено",
      studentRating: `Айгуль была моим репетитором полтора года. У нас были очные и онлайн занятия, оба варианта меня полностью устраивали. Атмосфера во время занятий была дружелюбной, я чувствовал индивидуальный подход.`,
      chooseTeacher: "Как найти идеального преподавателя",
      clearAssessment: "Чёткие критерии оценки",
      whatIsPunctuality: "Как найти самых пунктуальных преподавателей?",
      howToFindACompetentTeacher: "Как найти компетентного преподавателя",
      howToFindAResultOrientedTeacher:
        "Как найти преподавателя, дающего результаты",
      howToFindThePerfectTeacher: "Как найти идеального преподавателя",
      demanding: "Высокие стандарты",
      howLesson: "Как проходит урок?",
      aboutUs: "О нас",
      ourTeachers: "Наши преподаватели",
      aigul: "Айгуль",
      experience: "Сертифицированный преподаватель с 5-летним опытом",
      readMoreBtn: "Подробнее",
      chooseATeacher: "Выбрать преподавателя",
      becomeATeacher: "Стать преподавателем",
      whatIsYourLevel: "Какой у вас уровень языка?",
      doTheTest:
        "Пройдите тест, и мы вышлем видео с анализом ошибок, индивидуальный план обучения и подберём идеального преподавателя.",
      tryItNow: "Попробовать сейчас",
      weHelpLearners: `Мы помогаем ученикам и преподавателям найти друг друга и построить эффективные отношения`,
      guaranteedBenefits: "Гарантированные преимущества",
      toTheStudents: "Студентам",
      realRating: `Реальные отзывы вместо рекламы`,
      riskFree: "Безрисковая стратегия поиска преподавателя",
      studyMotivated: "Учитесь у самых мотивированных преподавателей",
      workWithout:
        "Работайте без посредников, платите только за профессионализм преподавателя",
      noWaitList:
        "Без списков ожидания. Договаривайтесь с преподавателем напрямую.",
      easyLearn:
        "Легко изучайте иностранные языки с профессиональными преподавателями.",
      toTheTeacher: "Преподавателям",
      anOpportunity: "Возможность развивать профессиональный бренд",
      avoidEmotional:
        "Избегайте эмоционального выгорания. Получайте обратную связь от студентов.",
      theOpportunityToTeach:
        "Возможность преподавать, самостоятельно устанавливая цену",
      increaseCost: `Повышайте стоимость часа, подтверждая свою компетентность`,
      increaseYourIncome:
        "Увеличивайте доход, переходя от индивидуальных к групповым занятиям",
      workWithoutInter:
        "Работайте без посредников, организуйте работу удобным способом",
      convenientTitle: "Одна удобная платформа вместо десятка приложений.",
      allYouNeed: "Всё необходимое в одном месте",
      doUVideoCall:
        "Звонки на Zoom? Читаете книги в другом окне? Используете интерактивную доску? Всё это в одном окне на нашей платформе",
      trackProgress: "Отслеживайте прогресс",
      inStudents: "В профиле студента видна успеваемость",
      stableVideoCall: "Стабильные видеозвонки",
      hdQuality: "HD-качество даже при низкой скорости интернета.",
      affordablePrice: "Доступные цены",
      weTake:
        "Мы берём символическую ежемесячную плату с преподавателей, не влияющую на стоимость уроков.",
      seeWhatInside: "Посмотрите, что внутри платформы",
      tryItYourself: "Попробуйте сами",
      audio: " Аудио",
      test: "Тесты",
      dictionary: "Словарь",
      board: " Доска",
      planPrices: "Цены",
      forThePlatform: "$ за саму платформу",
      useItForFree: "Используйте бесплатно",
      tryIt: "Попробовать",
      currency: "$10",
      monthly: "USD в месяц",
      firstMonth: "Первый месяц бесплатно",
      aboutFounder: "О нашем основателе",
      goToProfile: "Перейти в профиль",
      ceoName: "Руслан Леонтьев",
      ceoExperience:
        "Преподаватель академического английского с 11-летним стажем.",
      ceoUniversity: "Выпускник Американского университета в Центральной Азии",
      ceo1Text: `Я говорю по-английски, потому что я из маленького города. В больших городах неоновые огни рекламы гипнотизируют. Реклама правит миром. Она заставляет нас верить в суперсилу образования. Конечно, они продают курсы.`,
      ceo2Text: `В моём городе всё иначе. У нас нет курсов английского, интернет медленный. Поэтому мы не слышали рекламы образовательных услуг. "Хочешь учить английский — иди к Галине Джораевне", — говорят у меня на родине. Здесь люди живут в тесном сообществе, делятся новостями, рекомендуют специалистов, и хорошая репутация — единственная маркетинговая стратегия. В 2007 году, вернувшись из армии, я решил получить образование. Конечно, я обратился к Галине. На её уроках я открыл новый мир, где молодые люди свободно говорили по-английски. Но они не останавливались...`,
      ceo3Text: `Студенты Галины стремились к совершенству: высший балл на международных экзаменах (TOЕFL, IELTS, SAT). Они мечтали поступить в престижный зарубежный университет на полную стипендию. Алишер поступил в Университет Вашингтона. Спартак уехал в Американский университет в Болгарии. Через четыре года на выпускном в АУЦА было шестеро учеников Галины, включая меня. В 2007 году, когда я впервые постучал в дверь своего учителя английского, обучение за границей не было рекламным слоганом, и многие мои прогрессивные друзья из столицы не верили, что это возможно. Тем не менее, мы, ученики Галины, достигли высоких результатов.`,
      ceo4Text: `В больших городах люди живут иначе. Все спешат. Они редко общаются, редко делятся рекомендациями по-настоящему профессиональных преподавателей. Когда они делятся историями успеха, они делают это неправильно. Движимые мифом о self-made man, они не называют имена тех, кто помог им достичь успеха. Таким образом, имена профессиональных преподавателей остаются неизвестными. Реклама заполняет пробел. Таким образом, реклама становится важнее репутации преподавателя.`,
      ceo5Text: `Я предлагаю простую стратегию выбора образовательного провайдера. Не верьте рекламе. Доверяйте только независимой оценке и отзывам. Lingua.community предлагает независимую оценку преподавателей английского языка на основе их рейтингов и честных отзывов.`,
      ceo6Text: `Проект посвящён памяти г-жи Ахмедовой Галины Джораевны, настоящего преданного учителя.`,
      hidden: "Скрыто",
      seeMore: "Читать далее",
      startTeaching: "Начните преподавать или изучать языки сегодня.",
      byRegister: `Регистрируясь на Lingua.community, вы становитесь частью новой культуры. Мы — сообщество успешных студентов, которые благодарят профессиональных преподавателей и рекомендуют их другим.`,
      connectAndJoin: "Присоединяйтесь",
      talkToUs: "Напишите нам в Telegram",
      companyName: "ООО «Леонтьев и партнёры»",
      terms: "Условия использования",
      personalInfo: "Политика конфиденциальности",
      europe: "При поддержке Accelerate Prosperity",
      socialNetworks: "Мы в соцсетях",
      techSupport: "Техподдержка в чате",
      firstRatingName: "Акылай Калбердиева",
      firstRatingDescription:
        "Учу английский у вас три месяца и повысила уровень с pre-intermediate до advanced.",
      firstRatingLessons: "42 урока завершено.",
      secondRatingName: "Жамиля Дунганова",
      secondRatingDescription: `Учу английский у вас три месяца и повысила уровень с pre-intermediate до advanced.`,
      secondRatingLessons: "158 уроков завершено.",
      thirdRatingName: "Салижан Жумалиев",
      thirdRatingDescription: `Мне 17 лет. Недавно сдал IELTS на 7.5 баллов. Благодарю своего преподавателя Леонтьева Руслана. Рекомендую всем.`,
      thirdRatingLessons: "216 уроков завершено",
      fourRatingName: "Адель Асаналиева",
      fourRatingDescription: `Поступила в Anglia Ruskin University в Кембридже на биомедицину. Хочу выразить благодарность моему преподавателю академического английского Руслану Леонтьеву, который помог мне подготовиться к международным экзаменам, поступить в престижный университет, а также способствовал моему личному росту.`,
      fourRatingLessons: "314 уроков завершено.",
    },
    termsOfService: {
      content:
        '<div class="text-center text-h5">Условия использования</div><div class="text-right">Дата вступления в силу: 15 июля 2024 года</div><div class="mt-2"><p>Добро пожаловать в <a href="https://lingua.community">lingua.community</a> (далее "Приложение"), оператором которого является ОсОО "Леонтьев и Партнеры" ("Компания", "мы", "нас" или "наш"), компания, зарегистрированная в Бишкеке, Кыргызстан. "мы" или "наш"), компанией, зарегистрированной в Бишкеке, Кыргызстан. Заходя на доступ к Приложению или его использование, вы соглашаетесь соблюдать и быть связанными следующие положения и условия ("Условия"). Пожалуйста, внимательно ознакомьтесь с настоящими Условиями перед использованием Приложения. Если вы не согласны с настоящими Условиями, вы не должны использовать Приложение. Переведено с помощью DeepL.com (бесплатная версия)</div><ol class="mt-3"><li><div>Учетные записи пользователей</div><ol><li><div>Регистрация</div><p>Пользователи могут создавать учетные записи в Приложении в качестве учителя или ученика (каждая из них - "Учетная запись"). Создавая учетную запись, вы заявляете и гарантируете, что предоставленная вами информация является точной, актуальной и полной. Вы несете ответственность за сохранение конфиденциальности и безопасности учетных данных вашей Учетной записи.<li><div>Типы аккаунтов</div><ul><li>Учителя: Пользователи, зарегистрированные как преподаватели, могут планировать видеовстречи, загружать образовательный контент, создавать викторины и тесты с мгновенной обратной связью и делиться ими с учениками.<li>Студенты: Пользователи, зарегистрированные как студенты, могут участвовать в онлайн-встречах, запланированных преподавателями, и получать доступ к образовательному контенту, созданному преподавателями.</ul><li><div>Возрастные ограничения и юридическая ответственность</div><ul><li>Услуги доступны и могут использоваться только лицами, достигшими 18 лет и способными заключать юридически обязывающие договоры в соответствии с действующим законодательством.<li>Лица в возрасте до 18 лет, но не моложе 13 лет, могут пользоваться нашими Услугами только вместе с родителем или законным опекуном и под его присмотром. Родитель или законный опекун всегда несет ответственность за все действия, связанные с использованием Услуг вышеупомянутыми лицами.</ul></ol><li class="mt-2"><div>Услуги онлайн-образования</div><ol><li><div>Особенности</div><ul><li>Приложение предоставляет инструменты для индивидуальных и групповых занятий в режиме реального времени, такие как видеовстречи, интерактивная онлайн-доска, викторины и тесты с мгновенной обратной связью.</ul><li><div>Оценка преподавателя</div><ul><li>Приложение предлагает инструменты для оценки профессиональных качеств преподавателей по трем критериям: пунктуальность, доказанные способности и развитие навыков.<li>Публичная оценка: Преподаватель соглашается публично выставлять оценки, полученные им через оценки студентов, и отзывы, которые студенты оставляют о его преподавательской деятельности, независимо от того, являются ли эти оценки и отзывы положительными или отрицательными. Компания не исправляет отзывы и оценки, за исключением случаев, когда Ученик намеренно оскорбляет, обзывается.</ul><li><div>Услуги платформы</div><ul><li>Компания не предоставляет образовательных услуг самостоятельно. Наоборот, <b>**lingua.community**</b> предоставляет инструменты для взаимодействия преподавателей и студентов.</ul></ol><li class="mt-2"><div>Финансовая и методологическая независимость</div><ol><li><div>Политика оплаты</div><ul><li>Компания не является посредником в финансовых, методических и дисциплинарных вопросах между Преподавателями и Учениками. Стоимость и порядок оплаты онлайн-урока, а также порядок отмены урока определяются исключительно Преподавателем и Учеником.</ul><li><div>Разногласия</div><ul><li>В случае возникновения разногласий между студентом и преподавателем по поводу недоплаты, несвоевременной оплаты, политики отмены уроков или любых других финансовых вопросов, Компания не несет ответственности.</ul><li><div>Обязанности по уплате налогов и лицензированию</div><ul><li>Преподаватели несут ответственность за уплату всех необходимых налогов и получение необходимых лицензий в соответствии с налоговым законодательством страны, в которой они работают. Например, преподаватели из Кыргызстана должны приобрести патент репетитора и оплатить сертификат социального фонда.</ul></ol><li class="mt-2"><div>Отзывы студентов</div><ol><li><div>Свидетельские права</div><ul><li>Студенты имеют право писать отзывы об услугах своего преподавателя и оценивать его профессиональные качества. Компания не исправляет и не изменяет отзывы, за исключением случаев, когда ученики обзывают, унижают, позорят учителя или дискриминируют группу людей по этническому, национальному, религиозному, гендерному признаку. Любой пользователь может сообщить о таком нарушении через мессенджеры Telegram по адресу <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a> или <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a> или позвонив по прямому номеру <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a></ul><li><div>Формат свидетельства</div><ul><li>Компания укажет количество уроков, проведенных учеником до написания отзыва, и добавит эту информацию в текст отзыва.<br>Например, если ученик по имени Руслан взял 10 онлайн-уроков у конкретного преподавателя по имени Гэрри Гудсон, и Руслан написал: "Мистер Гэрри Гудсон - очень компетентный преподаватель. Он отвечает на все мои вопросы и приводит дополнительные примеры, исключения из правил, которые не упоминаются в учебнике", то отзыв появится на сайте в следующем виде: "Руслан взял 10 уроков у Гарри Гудсона". Руслан написал: "Мистер Гарри Гудсон - очень компетентный преподаватель. Он отвечает на все мои вопросы и приводит дополнительные примеры, а также исключения из правил, которые не упоминаются в учебнике".</ul></ol><li class="mt-2"><div>Поведение пользователя</div><ol><li><div>Загрузка содержимого</div><ul><li>Пользователи несут ответственность за любой контент, который они загружают, передают или создают с помощью Приложения. Компания оставляет за собой право удалять любой контент, нарушающий настоящие Условия или действующее законодательство, особенно если контент нарушает авторские права, содержит любые виды дискриминации, включая, но не ограничиваясь этнической, гендерной или национальной.</ul><li><div>Запрещенная деятельность</div><ul><li>Нарушение авторских прав: Учителям запрещено использовать материалы и контент, на которые распространяется запрет на авторское право. Если учитель использует материалы и контент, нарушающие авторские права, его аккаунт будет закрыт, а контент, нарушающий авторские права, будет удален без возможности восстановления.<li>Пользователи могут загружать контент из приложения, но только для личного использования. Распространять загруженный из приложения контент третьим лицам запрещено.<li>Пользователи не должны использовать Приложение для каких-либо незаконных целей или заниматься любой деятельностью, которая нарушает или мешает работе Приложения.</ul><li><div>Взаимодействие с пользователем и личная безопасность</div><p>Компания не поддерживает и не делает никаких заявлений или гарантий относительно точности, полноты и надежности любой информации, предоставленной учителем или учеником. lingua.community не может подтвердить, что каждый Пользователь является тем, за кого себя выдает. При общении с другими Пользователями следует проявлять осторожность и здравый смысл для защиты своей личной безопасности и имущества, как и при общении с незнакомыми людьми. Ни Компания, ни lingua.community не несут ответственности за поведение, как онлайн, так и офлайн, любого Пользователя Услуг.<li><div>Предотвращение мошенничества и кражи личных данных</div><p>Пользователи должны отвечать только на сообщения, отправленные через наши официальные каналы связи: Telegram <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a> или <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a>, и WhatsApp <a href="https://wa.me/996554877853">+996 (554) 877-853</a>.<br>Любые попытки связаться с нашими пользователями по другим каналам, утверждая, что они представляют компанию, считаются злонамеренной попыткой кражи личных данных.<p>Пользователи никогда не должны сообщать номера своих кредитных карт, идентификационные номера паспортов или любую другую конфиденциальную информацию на сайтах, не имеющих в качестве корневого домена lingua.community. Компания не продает подписки с использованием других сайтов.</ol><li class="mt-2"><div>Сборы и платежи</div><ol><li><div>Абонентская плата для учителей</div><ul><li>За пользование приложением с учителей ежемесячно взимается плата в размере 1000 сомов (кыргызских сомов). Если в платежной операции используется валюта, отличная от кыргызских сомов (KGS), сумма платежа будет рассчитана по курсу национального банка Кыргызстана на момент совершения операции.</ul></ol><li class="mt-2"><div>Интеллектуальная собственность</div><ol><li><div>Владение</div><ul><li>Приложение и все его содержимое, функции и функциональные возможности принадлежат Компании или ее лицензиарам и защищены международными законами об авторском праве, товарных знаках, патентах, коммерческой тайне и другими законами об интеллектуальной собственности или правах собственности.</ul><li><div>Лицензия</div><ul><li>Пользователям предоставляется ограниченная, неисключительная, не подлежащая передаче и отзывная лицензия на использование Приложения в личных или образовательных целях в соответствии с настоящими Условиями.</ul></ol><li class="mt-2"><div>Отказ от гарантий</div><p>Приложение предоставляется на условиях «как есть» и «как доступно». Компания не дает никаких гарантий, явных или подразумеваемых, в отношении работы Приложения или информации, контента или материалов, включенных в него.<li class="mt-2"><div>Ограничение ответственности</div><p>Ни при каких обстоятельствах Компания не несет ответственности за любые косвенные, случайные, особые, косвенные или штрафные убытки, возникшие в результате или связанные с использованием вами Приложения.<li class="mt-2"><div>Изменения в Условиях</div><p>Компания оставляет за собой право изменять настоящие Условия в любое время. Любые изменения вступят в силу немедленно после публикации пересмотренных Условий в Приложении. Ваше дальнейшее использование Приложения после публикации пересмотренных Условий означает ваше согласие с изменениями.<li class="mt-2"><div>Применимое право</div><p>Настоящие Условия регулируются и толкуются в соответствии с законодательством Кыргызской Республики без учета принципов коллизионного права.<li class="mt-2"><div>Контактная информация</div><p>По любым вопросам или сомнениям относительно настоящих Условий свяжитесь с нами по адресу:<br><br>ООО «Леонтьев и партнеры»<br>[Юг-2, д.14]<br>Бишкек, Кыргызстан<br>Telegram: <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a><br>Tel: <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a><li class="mt-2"><div>Политика использования файлов cookie для зарегистрированных и незарегистрированных пользователей</div><p>В настоящей Политике использования файлов cookie объясняется, как сайт lingua.community («мы», «нас» или «наш»), которым управляет ООО «Леонтьев и партнеры», использует файлы cookie и аналогичные технологии, чтобы узнавать вас, когда вы посещаете наш веб-сайт по адресу https://lingua.community. В нем объясняется, что это за технологии, почему мы их используем, а также ваши права контролировать их использование.<ol><li><div>Что такое файлы cookie?</div><p>Файлы cookie — это небольшие файлы данных, которые сохраняются на вашем компьютере или мобильном устройстве при посещении веб-сайта. Файлы cookie широко используются владельцами веб-сайтов для обеспечения работы или повышения эффективности их веб-сайтов, а также для предоставления отчетной информации.<li><div>Почему мы используем файлы cookie?</div><p>Мы используем файлы cookie по нескольким причинам. Некоторые файлы cookie необходимы по техническим причинам для работы нашего веб-сайта, и мы называем их «необходимыми» или «строго необходимыми» файлами cookie. Другие файлы cookie позволяют нам отслеживать и ориентироваться на интересы наших пользователей, чтобы улучшить качество обслуживания на нашем веб-сайте. Например, мы используем файлы cookie, чтобы узнавать вас, когда вы возвращаетесь на наш веб-сайт, чтобы предоставлять соответствующий контент и обнаруживать потенциальные угрозы безопасности.<li><div>Типы файлов cookie, которые мы используем:</div><ol><li>Основные файлы cookie. Эти файлы cookie строго необходимы для предоставления вам услуг, доступных через наш веб-сайт, и для использования некоторых его функций, таких как доступ к защищенным областям.<li>Файлы cookie производительности и функциональности. Эти файлы cookie используются для повышения производительности и функциональности нашего веб-сайта, но не являются обязательными для его использования. Однако без этих файлов cookie некоторые функции (например, видео) могут стать недоступными.<li>Файлы cookie аналитики и настройки. Эти файлы cookie собирают информацию, которая используется либо в совокупной форме, чтобы помочь нам понять, как используется наш веб-сайт или насколько эффективны наши маркетинговые кампании, либо чтобы помочь нам настроить наш веб-сайт для вас.<li>Файлы cookie безопасности. Эти файлы cookie помогают выявлять и предотвращать угрозы безопасности. Мы используем эти файлы cookie для аутентификации пользователей и защиты пользовательских данных от посторонних лиц.</ol><li><div>Ваш выбор в отношении файлов cookie</div><p>Вы имеете право решать, принимать или отклонять файлы cookie. Вы можете воспользоваться своими предпочтениями в отношении файлов cookie, настроив или изменив элементы управления веб-браузером, чтобы принимать или отклонять файлы cookie. Если вы решите отказаться от файлов cookie, вы все равно сможете использовать наш веб-сайт, хотя ваш доступ к некоторым функциям и областям нашего веб-сайта может быть ограничен.<li><div>Как удалить файлы cookie</div><p>Если вы хотите удалить файлы cookie или указать своему веб-браузеру удалить или отказаться от файлов cookie, посетите страницы помощи вашего веб-браузера:<ol><li>Для Chrome: [Google Chrome] ( <a href="https://support.google.com/chrome/answer/95647" target="_blank">https://support.google.com/chrome/answer/95647 </a>)<li>Для Internet Explorer: [Microsoft Internet Explorer] ( <a href="https://support.microsoft.com/kb/278835" target="_blank">https://support.microsoft.com/kb/278835 </a>)<li>Для Firefox: [Mozilla Firefox] ( <a href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored" target="_blank">https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored </a>)<li>Для Safari: [Apple Safari] ( <a href="https://support.apple.com/guide/safari/sfri11471/mac" target="_blank">https://support.apple.com/guide/safari/sfri11471/mac </a>)</ol><p>Обратите внимание: если вы удалите файлы cookie или откажетесь принять их, вы не сможете использовать все предлагаемые нами функции, вы не сможете сохранить свои предпочтения, а некоторые наши страницы могут отображаться некорректно.<li><div>Изменения в настоящей Политике использования файлов cookie</div><p>Мы можем время от времени обновлять настоящую Политику в отношении файлов cookie, чтобы отражать, например, изменения в используемых нами файлах cookie или по другим эксплуатационным, юридическим или нормативным причинам. Пожалуйста, регулярно просматривайте настоящую Политику в отношении файлов cookie, чтобы быть в курсе использования нами файлов cookie и связанных с ними технологий.</ol></ol><p class="mt-2">ООО «Леонтьев и партнеры»<br>[Юг-2, д.14]<br>Бишкек, Кыргызстан<br>Telegram: <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a>, <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a><br>Тел.: <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a><p>Используя наш веб-сайт, вы подтверждаете, что прочитали, поняли и соглашаетесь соблюдать настоящую Политику использования файлов cookie.',
    },
    privacyPolicy: {
      content:
        '<div class="mx-2 my-4"><div class="text-center text-h5">Политика конфиденциальности</div><div class="text-right">Дата вступления в силу: 15 июля 2024 года</div><div class="mt-2"><p>Добро пожаловать в сообщество Lingua ("мы", "наш", "нас"). Настоящая политика конфиденциальности объясняет, как Leontev and Partners LLC, расположенная в Кыргызстане, г. Бишкек, Юг-2, д. 14 ("Компания"), собирает, использует, раскрывает и защищает ваши данные при посещении нашего веб-сайта <a href="https://lingua.community">lingua.community</a> и использовании наших услуг. Используя наш веб-сайт, вы соглашаетесь с условиями настоящей политики конфиденциальности. Текущая Политика конфиденциальности приложения включена в Соглашение об использовании приложения.</div><ol class="mt-3"><li><div>Собираемая информация</div><ul><li><div>Персональные данные</div><p>При регистрации учителем или учеником через вашу учетную запись Google мы собираем ваше полное имя, фотографию профиля и адрес электронной почты. Эти данные становятся доступными для публичного доступа на нашей платформе.<li><div>Данные, специфичные для учителей</div><p>Учителя предоставляют образовательные услуги и оцениваются студентами по критериям, таким как пунктуальность, компетентность, развитие навыков и другим параметрам. Эти оценки являются общедоступными.<li><div>Отзывы</div><p>Мы собираем и отображаем отзывы об образовательных услугах, предоставляемых на платформе. Учитель соглашается принять отзывы от студентов без изменения их содержания. Отзывы содержат полные имена учителя и студента, а также количество проведенных уроков до публикации отзыва. Количество проведенных уроков на веб-сайте автоматически отслеживается и хранится в вашем личном профиле. Количество проведенных уроков с конкретным студентом становится общедоступным только после получения отзыва от студента.<li><div>Данные использования</div><p>Мы собираем информацию о ваших взаимодействиях с нашим веб-сайтом, таких как посещенные страницы, время и дата визитов, количество проведенных уроков, ваш IP-адрес и местоположение, а также другие диагностические данные.<li><div>Файлы cookie и аналогичные технологии</div><p>Мы используем файлы cookie для определения вашего IP-адреса и местоположения, а также для улучшения общего пользовательского опыта. Эти технологии помогают нам понять, как вы взаимодействуете с нашими услугами и предоставить лучший опыт.</ul><li><div>Как мы используем ваши данные</div><p>Мы используем собранную информацию для:<ul><li>Предоставления и поддержки наших услуг<li>Отображения профилей учителей и их оценок для незарегистрированных пользователей<li>Отображения отзывов с именами и количеством уроков<li>Уведомления вас об изменениях в наших услугах<li>Предоставления поддержки клиентам<li>Анализа использования нашего веб-сайта для улучшения наших услуг<li>Выявления, предотвращения и устранения технических проблем<li>Соблюдения юридических обязательств и обеспечения соблюдения наших условий</ul><li><div>Передача ваших данных</div><p>Мы не продаем и не передаем вашу личную информацию третьим лицам, за исключением случаев:<ul><li>С вашего согласия<li>Отображения профилей учителей и их оценок для незарегистрированных пользователей<li>Для выполнения юридических обязательств<li>Для защиты и защиты наших прав и собственности<li>С поставщиками услуг для выполнения работ от нашего имени<li>В связи с любым объединением, продажей активов компании, финансированием или приобретением всего или части нашего бизнеса другой компанией</ul><li><div>Публично доступная информация</div><ul><li>Профили учителей, включая полные имена, фотографии профилей, оценки и отзывы, доступны для общего доступа любому пользователю.<li>Отзывы включают полные имена как учителя, получающего отзыв, так и студента, написавшего отзыв, а также количество проведенных уроков.</ul><li><div>Безопасность вашей информации</div><p>Мы используем административные, технические и физические меры безопасности для защиты вашей личной информации. Однако ни один метод передачи данных через интернет или электронное хранение не является 100% безопасным.<li><div>Ваши права на защиту данных</div><p>В зависимости от вашего местоположения у вас могут быть следующие права в отношении ваших персональных данных:<ul><li>Право на доступ<li>Право на исправление<li>Право на удаление<li>Право на ограничение обработки<li>Право на портабельность данных<li>Право на возражение</ul><li><div>Политика файлов cookie и аналогичных технологий</div><p>Мы используем файлы cookie и аналогичные технологии для:<ul><li>Определения вашего IP-адреса и местоположения<li>Улучшения взаимодействия и опыта пользователей на нашем веб-сайте</ul><p>Вы можете управлять предпочтениями файлов cookie через настройки вашего браузера. Для получения дополнительной информации о том, как управлять файлами cookie и аналогичными технологиями, пожалуйста, ознакомьтесь с нашей <a href="/terms-and-conditions-agreement">[Политикой использования файлов cookie]</a><li><div>Услуги третьих сторон</div><p>Наши услуги могут содержать ссылки на веб-сайты или услуги третьих сторон, включая Google. Мы не контролируем эти сайты третьих сторон и не несем ответственности за их политику конфиденциальности. Мы рекомендуем вам ознакомиться с политикой конфиденциальности этих третьих сторон.<li><div>Конфиденциальность детей</div><p>Наши услуги не предназначены для лиц младше 13 лет. Мы не собираем намеренно личную информацию от детей младше 13 лет. Если мы узнаем, что мы собрали личную информацию от ребенка младше 13 лет, мы примем меры по удалению такой информации.<li><div>Изменения в настоящей Политике конфиденциальности</div><p>Мы можем время от времени обновлять нашу Политику конфиденциальности. Мы уведомим вас о любых изменениях, разместив новую Политику конфиденциальности на этой странице и обновив "Дата вступления в силу" вверху.<li><div>Свяжитесь с нами</div><p>Если у вас есть вопросы по поводу настоящей Политики конфиденциальности, пожалуйста, свяжитесь с нами по адресу <a href="mailto:skypestudy.org@gmail.com">skypestudy.org@gmail.com</a> и/или WhatsApp <a href="https://wa.me/996554877853">+996 (554) 877-853</a></ol><p class="mt-2">Leontev and Partners LLC<br>[Юг-2, д. 14]<br>Бишкек, Кыргызстан<br>Telegram: <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a>, <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a><br>Tel: <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a><p>Используя наш веб-сайт, вы подтверждаете, что ознакомились, поняли и согласны с настоящей Политикой конфиденциальности.</div>',
    },
  },
  messages: {
    lessonDeleted: "Урок удалён",
    audioDeleted: "Аудио удалено",
    attachmentDeleted: "Вложение удалено",
    exerciseDeleted: "Задание удалено",
    exerciseSaved: "Задание сохранено",
    lessonCreated: "Урок создан",
    quizDeleted: "Тест удалён",
    quizUnlinked: "Тест отвязан",
    quizCreated: "Тест создан",
  },
  buttons: {
    cancel: "Отмена",
    ignore: "Игнорировать",
    ok: "OK",
    delete: "Удалить",
    unlink: "Отвязать",
    create: "Создать",
    save: "Сохранить",
    update: "Обновить",
    check: "Проверить",
    link: "Связать",
    submit: "Отправить",
    confirm: "Подтвердить",
    quit: "Выйти",
    back: "Назад",
    previous: "Предыдущий",
    next: "Следующий",
    preview: "Предпросмотр",
    edit: "Редактировать",
    view: "Просмотреть",
    join: "Присоединиться",
    close: "Закрыть",
  },
  editor: {
    enterUrl: "Введите URL",
    enterImageUrl: "Введите URL изображения",
    enterVideoUrl: "Введите URL видео",
    unlink: "Отвязать",
    link: "Связать",
    add: "Добавить",
    title: "Название",
    submit: "Отправить",
    cancel: "Отмена",
  },
  common: {
    all: "Все",
    confirmDialog: "Подтвердить действие?",
  },
  date: {
    months: {
      short: [
        "Янв",
        "Фев",
        "Мар",
        "Апр",
        "Май",
        "Июн",
        "Июл",
        "Авг",
        "Сен",
        "Окт",
        "Ноя",
        "Дек",
      ],
      full: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ],
    },
  },
  fileBrowser: {
    delete: {
      title: "Удалить",
      description: "Удалить этот <b>{type}</b>?<br><em>{baseName}</em>",
      suffix: {
        folder: "папку",
        file: "файл",
      },
    },
    cancel: "Отмена",
    select: "Выбрать",
    yes: "Да",
    selectFolderOrFile: "Выберите папку или файл",
    file: "Файл",
    size: "Размер",
    noFilesOrFoldersFound: "Файлы/папки не найдены",
    folderIsEmpty: "Папка пуста",
    upTo: "До: {value}",
    createFolder: "Создать папку",
    uploadFiles: "Загрузить файлы",
    collapseAll: "Свернуть всё",
    uploadTo: "Загрузить в:",
    maxFilesCount: "Макс. файлов: {value}",
    maxFileSize: "Макс. размер: {value}",
    addFiles: "Добавить файлы",
    clear: "Очистить",
    upload: "Загрузить",
  },
  camera: {
    errors: {
      CAMERA_IS_OFF: {
        title: "Камера выключена",
      },
      CAMERA_PERMISSION_ERROR: {
        title: "Доступ к камере запрещён",
        description:
          "Разрешите доступ в настройках браузера и перезагрузите страницу",
      },
      CAMERA_UNAVAILABLE_ERROR: {
        title: "Камера недоступна",
        description: "Браузер не смог предоставить доступ к камере",
      },
      MIC_PERMISSION_ERROR: {
        title: "Доступ к микрофону запрещён",
        description:
          "Разрешите доступ в настройках браузера и перезагрузите страницу",
      },
      MIC_UNAVAILABLE_ERROR: {
        title: "Микрофон недоступен",
        description: "Браузер не смог предоставить доступ к микрофону",
      },
    },
  },
  selectContacts: {
    form: {
      query: {
        placeholder: "Введите имя контакта",
      },
    },
  },
  time: {
    startsIn: "Начнётся <b>{time}</b>",
    endsIn: "Закончится <b>{time}</b>",
    ended: "Закончился <b>{time}</b>",
    cancelled: "Отменён <b>{time}</b>",
  },
  targetLanguages: {
    english: "Английский",
    russian: "Русский",
    kyrgyz: "Кыргызский",
    kazakh: "Казахский",
    uzbek: "Узбекский",
    turkmen: "Туркменский",
    armenian: "Армянский",
  },
  languageLevels: {
    A1: "Начальный",
    A2: "Элементарный",
    B1: "Средний",
    B2: "Выше среднего",
    C1: "Продвинутый",
    C2: "Профессиональный",
  },
  specialityGroups: {
    beginner: {
      title: "Для начинающих",
      items: {
        general: {
          title: "Общий",
          shortTitle: "Общий",
        },
        preschoolers: {
          title: "Дошкольники",
          shortTitle: "Дошкольники",
        },
        schoolChildrenPrimary: {
          title: "Младшие школьники",
          shortTitle: "Младшая школа",
        },
      },
    },
    intermediate: {
      title: "Средний уровень",
      items: {
        interview: {
          title: "Подготовка к собеседованию (виза/работа)",
          shortTitle: "Собеседование",
        },
        speakingPractice: {
          title: "Разговорная практика (беглость)",
          shortTitle: "Разговорная практика",
        },
        examPreparation: {
          title: "Подготовка к экзаменам (ОГЭ/ЕНТ/ОРТ)",
          shortTitle: "Экзамены",
        },
        schoolChildrenSecondary: {
          title: "Средние школьники",
          shortTitle: "Средняя школа",
        },
      },
    },
    advanced: {
      title: "Продвинутый уровень",
      items: {
        business: {
          title: "Деловой английский",
          shortTitle: "Деловой",
        },
        aviation: {
          title: "Авиационный английский",
          shortTitle: "Авиационный",
        },
        medicine: {
          title: "Медицинский английский",
          shortTitle: "Медицинский",
        },
        examPreparation: {
          title: "Подготовка к экзаменам (IELTS/TOEFL/SAT)",
          shortTitle: "Международные экзамены",
        },
        academicEnglish: {
          title: "Академический английский (университет)",
          shortTitle: "Академический",
        },
        technicalEnglish: {
          title: "Технический английский (IT и инженерия)",
          shortTitle: "Технический",
        },
        legalEnglish: {
          title: "Юридический английский",
          shortTitle: "Юридический",
        },
      },
    },
  },
};
